import { useDispatch, useSelector } from 'react-redux';
import { RootAppState } from '../store';
import { hideAlertAction, showAlertAction } from './alertActions';
import { AlertState, AlertAction } from './alertTypes';

export const useAlert = (): [
  (titulo: string, mensagem: string, actions?: Array<AlertAction>) => void,
  () => void,
  AlertState
] => {
  const dispatch = useDispatch();
  const alert = useSelector((state: RootAppState) => state.alert);

  const mostrarAlert = (titulo: string, mensagem: string, actions?: Array<AlertAction>) => {
    const action = showAlertAction({ titulo, mensagem, actions, show: true });
    dispatch(action);
  };

  const fecharAlert = () => {
    const action = hideAlertAction();
    dispatch(action);
  };

  return [mostrarAlert, fecharAlert, alert];
};
